//A decorator for Custom Survey Sections to define how to calculate "completed-ness"
export const SurveyCustomSectionValidatorEnhance = completeLogic => constructor => class extends constructor {
    static isSectionComplete(survey, section, customData) {
        return completeLogic?.(survey, section, customData);
    }
}